async function needShowPopup() {
  if (window._erj_?.customerIsLoggedIn && window._erj_?.customerEmail) {
    const url = `https://${window._erj_.backendDomain}/should_show_popup`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: window._erj_.customerEmail,
      }),
      mode: "cors",
      signal: AbortSignal.timeout(20000),
    });
    const res = await response.json();
    return res.data;
  }

  return window._erj_?.setnxCache("newsletter_popup", 1, 86400 * 1);
}

function closeNewlettersPopup() {
  const modal = document.getElementById("new-newsletter-popup");
  modal.close();
}

function trackSubscribePopupOpen(isManually) {
  if (typeof window.gtag === "function") {
    window.gtag("event", "subscribe_popup_open", {
      popup_type: "newsletter",
      isManually,
    });
    return;
  }
  if (Array.isArray(window.gtag) && typeof window.gtag.push === "function") {
    window.gtag.push(["event", "subscribe_popup_open", { popup_type: "newsletter", isManually }]);
  }
}

function initHandleSubscribeEvent() {
  const subscribeButton = document.getElementById("new-popup-subscribe-button");
  const emailInput = document.getElementById("new-newsletter-email-input");
  const subscribeButtonText = document.getElementById("new-popup-subscribe-button-text");
  const subscribeButtonLoading = document.getElementById("new-popup-subscribe-button-loading");

  const formModal = document.getElementById("new-newsletter-popup-content");
  const alreadySubscribedModal = document.getElementById("new-newsletter-popup-already-subscribed");
  const successModal = document.getElementById("new-newsletter-popup-success");

  subscribeButton.addEventListener("click", async (e) => {
    e.preventDefault();

    if (!emailInput || !emailInput.checkValidity()) {
      console.log("emailInput is not valid");
      emailInput.reportValidity();
      const validatorHint = document.getElementById("new-newsletter-email-hint");
      if (validatorHint) {
        validatorHint.classList.remove("tw:hidden");
      }
      return;
    }
    const validatorHint = document.getElementById("new-newsletter-email-hint");
    if (validatorHint) {
      validatorHint.classList.add("tw:hidden");
    }

    subscribeButtonText.classList.add("tw:hidden");
    subscribeButtonLoading.classList.remove("tw:hidden");
    subscribeButton.classList.add("tw:cursor-not-allowed");

    const url = `https://${window._erj_.backendDomain}/subscribe`;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: emailInput.value,
        isLoggedIn: window._erj_?.customerIsLoggedIn,
        utm_campaign: urlSearchParams.get("utm_campaign") || "",
        utm_source: urlSearchParams.get("utm_source") || "",
        utm_medium: urlSearchParams.get("utm_medium") || "",
      }),
      mode: "cors",
      signal: AbortSignal.timeout(20000),
    });

    const res = await response.json();
    const data = res?.data || {};
    if (!data.success || data?.followUp === -1) {
      console.error("subscribe failed");
      subscribeButtonText.classList.remove("tw:hidden");
      subscribeButtonLoading.classList.add("tw:hidden");
      return;
    }

    const modalEl = document.getElementById("new-newsletter-popup");
    if (data?.followUp === 0 || data?.followUp === 1) {
      formModal.classList.add("tw:!hidden");
      formModal.setAttribute("aria-hidden", "true");
      successModal.classList.remove("tw:!hidden");
      successModal.setAttribute("aria-hidden", "false");
    } else if (data?.followUp === 2 || data?.followUp === 3) {
      formModal.classList.add("tw:!hidden");
      formModal.setAttribute("aria-hidden", "true");
      alreadySubscribedModal.classList.remove("tw:!hidden");
      alreadySubscribedModal.setAttribute("aria-hidden", "false");
    }

    subscribeButtonText.classList.remove("tw:hidden");
    subscribeButtonLoading.classList.add("tw:hidden");
  });
}

function initFooterNewsletterPopup() {
  const subscribeButton = document.getElementById("footer-subscribe-button");
  const emailInput = document.getElementById("footer-subscribe-email-input");
  const subscribeButtonText = document.getElementById("footer-subscribe-button-text");
  const loadingIndicator = document.getElementById("footer-subscribe-button-loading");
  const successContainer = document.getElementById("footer-newsletter-success-container");
  const alreadySubscribedContainer = document.getElementById("footer-newsletter-already-subscribed-container");
  const formContainer = document.getElementById("footer-newsletter-email-container");

  const policyCheckbox = document.getElementById("footer-policy-note-checkbox");

  function updateSubscribeButtonState() {
    if (policyCheckbox.checked) {
      subscribeButton.removeAttribute("disabled");
      subscribeButton.classList.remove("tw:opacity-50", "tw:cursor-not-allowed");
    } else {
      subscribeButton.setAttribute("disabled", "disabled");
      subscribeButton.classList.add("tw:opacity-50", "tw:cursor-not-allowed");
    }
  }

  // Initial check
  updateSubscribeButtonState();

  policyCheckbox.addEventListener("change", updateSubscribeButtonState);

  subscribeButton.addEventListener("click", async (e) => {
    e.preventDefault();

    if (subscribeButton.getAttribute("aria-busy") === "true" || !policyCheckbox.checked || !emailInput.value) {
      return;
    }

    subscribeButtonText.classList.add("tw:hidden");
    loadingIndicator.classList.remove("tw:hidden");
    subscribeButton.classList.add("tw:cursor-not-allowed");
    subscribeButton.setAttribute("aria-busy", "true");

    const url = `https://${window._erj_.backendDomain}/subscribe`;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: emailInput.value,
        isLoggedIn: window._erj_?.customerIsLoggedIn,
        utm_campaign: urlSearchParams.get("utm_campaign") || "",
        utm_source: urlSearchParams.get("utm_source") || "",
        utm_medium: urlSearchParams.get("utm_medium") || "",
      }),
      mode: "cors",
      signal: AbortSignal.timeout(20000),
    });

    const res = await response.json();
    const data = res?.data || {};
    if (data?.followUp === 0 || data?.followUp === 1) {
      formContainer.classList.add("tw:hidden");
      successContainer.classList.remove("tw:hidden");
    } else if (data?.followUp === 2 || data?.followUp === 3) {
      formContainer.classList.add("tw:hidden");
      alreadySubscribedContainer.classList.remove("tw:hidden");
    }

    subscribeButtonText.classList.remove("tw:hidden");
    loadingIndicator.classList.add("tw:hidden");
    subscribeButton.classList.remove("tw:cursor-not-allowed");
    subscribeButton.setAttribute("aria-busy", "false");
  });
}

function openNewsletterPopup() {
  const modal = document.getElementById("new-newsletter-popup");
  if (modal) {
    modal.showModal();
    trackSubscribePopupOpen(true);
    initHandleSubscribeEvent();
    const emailInputEl = document.getElementById("new-newsletter-email-input");
    if (emailInputEl && emailInputEl.focus) {
      emailInputEl.focus();
    }
  }
}

window.openNewsletterPopup = openNewsletterPopup;

document.addEventListener("DOMContentLoaded", async function () {
  initFooterNewsletterPopup();
  const modal = document.getElementById("new-newsletter-popup");

  if (!modal) {
    return;
  }

  const delaySeconds = 5;
  const shouldShowPopup = await needShowPopup();
  if (!shouldShowPopup) {
    return;
  }

  let hasStartedTimer = false;
  const scrollHandler = () => {
    if (!hasStartedTimer) {
      hasStartedTimer = true;
      setTimeout(() => {
        modal.showModal();
        trackSubscribePopupOpen(false);
        initHandleSubscribeEvent();
        const emailInputEl = document.getElementById("new-newsletter-email-input");
        if (emailInputEl && emailInputEl.focus) {
          emailInputEl.focus();
        }
      }, delaySeconds * 1000);

      window.removeEventListener("scroll", scrollHandler);
    }
  };

  window.addEventListener("scroll", scrollHandler);
});
